import videojs from 'video.js'

/**
 * Sets up video list that appears on hover icon
 * @param {Player} player
 * @param {Object} options
 */
const setupVideoList = (player, options) => {
  if (options.enable) {
    const VideoList = videojs.getComponent('VideoList')
    let videoList = new VideoList(player, options)
    const videoListEl = videoList.contentEl()
    videoListEl.classList = 'vjs-playlist-list vjs-control'
    options.animationHandler(videoListEl)
    player.getChild('controlBar').addChild(videoList)
  }
}

export default setupVideoList
